const BusinessEntity = require('./business_entity').default;

class Creditor extends BusinessEntity {};

export default Creditor;
